// import $ from "jquery";

/*
 * Gallery
 */

$('.c-work__gallery').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    adaptiveHeight: true,
    centerPadding: 0

});

/*
 * Init logo gif launcher
 */

const $navLogo = $( '.c-nav__logo' );
const $overlay = $( '.js-overlay' );
const $alloverGif = $( '.js-allover-gif' );
const gifsNum = $alloverGif.attr( 'data-gifs-length' );
const repeat = [ 'repeat', 'repeat-x', 'repeat-y', 'no-repeat' ];


if( $alloverGif.length > 0 ){

    $navLogo.bind('mouseenter', function() {
        const randNumber = Math.floor( Math.random() * ( gifsNum - 1 + 1 ) ) + 1;
        const randData = 'data-gif-' + randNumber;
        const randGif = $alloverGif.attr( randData );

        const img = new Image();
        img.src = randGif;

        const h = $( window ).height() - img.height;
        const w = $( window ).width() - img.width;

        const nh = Math.floor( Math.random() * h );
        const nw = Math.floor( Math.random() * w );

        const randDec = Math.floor( Math.random() * ( 10 - 1 + 1 ) ) + 1;

        $alloverGif.css(
            { 'background-image': 'url( ' + randGif + ' )', 'background-position': nh + 'px ' + nw + 'px', 'background-repeat': repeat[ Math.floor( Math.random() * ( 3 + 1 ) ) ], 'animation-name': 'animatedGif' + randDec }
        );

        $overlay.removeClass( 'u-visually-hidden' );
    } );

    $navLogo.bind('mouseleave', function() {
        $overlay.addClass( 'u-visually-hidden' );
        $alloverGif.css(
            { 'background-image': 'none', 'background-position': 'none', 'background-repeat': 'none', 'animation-name': 'none' }
        );
    } );

}



// WEBPACK FOOTER //
// ./resources/assets/scripts/app.js